import { ModalConfirmation, ModalConfirmationProps } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface DisconnectStripeAccountModalProps extends ModalConfirmationProps {
  isProcessing: boolean
  onConfirm: () => void
}

export const DisconnectStripeAccountModal = ({
  isProcessing,
  onConfirm,
  ...modalProps
}: DisconnectStripeAccountModalProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <ModalConfirmation
      {...modalProps}
      cancelLabel={t('settings.organization.card_payments.configuration.disconnect_modal.cancel_button')}
      danger
      message={t('settings.organization.card_payments.configuration.disconnect_modal.body')}
      okLabel={t('settings.organization.card_payments.configuration.disconnect_modal.confirm_button')}
      okLoading={isProcessing}
      onOk={onConfirm}
      title={t('settings.organization.card_payments.configuration.disconnect_modal.title')}
    />
  )
}
